import { t } from "i18next";

import { Box, Button, Typography } from "@mui/material";

import { primaryContainedButtonSx } from "@/src/theme/helpers";

interface MicrosoftLoginButtonProps {
  click: () => void;
  text: string;
}

const MicrosoftLoginButton = (props: MicrosoftLoginButtonProps) => {
  const { click, text } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        mt: 3,
        mb: 3
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: "text.primary",
          mb: 2,
          textAlign: "center"
        }}
      >
        {t("general.loginWithMicrosoft")}
      </Typography>
      <Button
        variant="contained"
        fullWidth
        sx={(muiTheme) => ({
          ...primaryContainedButtonSx(muiTheme),
          textTransform: "none",
          fontWeight: muiTheme.typography.fontWeightSemibold,
          fontSize: muiTheme.typography.h4.fontSize,
          borderRadius: "0",
          height: "50px",
          maxWidth: "320px",
          boxShadow: `0 2px 4px ${muiTheme.palette.misc.outlineBorder}`
        })}
        onClick={click}
      >
        {text}
      </Button>
    </Box>
  );
};

export default MicrosoftLoginButton;
